import { createSlice } from '@reduxjs/toolkit';
import { getAllCouriers } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const couriers = createSlice({
  name: 'couriers',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCouriers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllCouriers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllCouriers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export default couriers.reducer;
